import React from 'react';
import { TrendingUp, Shield, Clock, Lock } from 'lucide-react';

export const HeroSection = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-primary-light via-background to-background">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-primary/5 rounded-full blur-3xl" />
        <div className="absolute -bottom-20 -left-20 w-60 h-60 bg-primary/5 rounded-full blur-3xl" />
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-32">
        <div className="text-center max-w-4xl mx-auto">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary/10 text-primary text-sm font-medium mb-6">
            <TrendingUp className="h-4 w-4" />
            Pre-Series A Investment Round
          </div>
          
          {/* Main Heading with Lock Icon */}
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-foreground mb-6 tracking-tight">
            <span className="inline-flex items-center gap-3">
              Physiomobile
              <Lock className="h-8 w-8 sm:h-10 sm:w-10 text-primary/60" />
            </span>
            <span className="block text-primary mt-2">Investment Pledge</span>
          </h1>
          
          {/* Subtitle */}
          <p className="text-lg sm:text-xl text-muted-foreground mb-4 max-w-2xl mx-auto leading-relaxed">
            Indicate your intended investment amount to participate in Physiomobile&apos;s Pre-Series A round.
          </p>
          
          {/* Disclaimer */}
          <p className="text-sm text-muted-foreground/80 mb-10 max-w-xl mx-auto">
            This is a non-binding pledge. Final terms and documentation will be shared separately.
          </p>
          
          {/* Trust indicators */}
          <div className="flex flex-wrap items-center justify-center gap-6 sm:gap-10">
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Shield className="h-4 w-4 text-success" />
              <span>Secure &amp; Confidential</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Clock className="h-4 w-4 text-primary" />
              <span>Real-time Updates</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <TrendingUp className="h-4 w-4 text-warning" />
              <span>Active Fundraise</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
